import React from 'react';
import HeroSlider from '../components/home/HeroSlider';
import AboutIntro from '../components/home/AboutIntro';
import SetoZine from '../components/home/SetoZine';
import Pillars from '../components/home/Pillars';
import StatsRow from '../components/home/StatsRow';
import JoinUs from '../components/home/JoinUs';

const HomePage = () => {
  return (
    <div className="overflow-hidden">
      <HeroSlider />
      <AboutIntro />
      <Pillars />
      <SetoZine />
      <StatsRow />
      <JoinUs />
    </div>
  );
};

export default HomePage;